// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from './api/axios'
import VueCookie from 'vue-cookie'
import utils from './assets/js/utils'
import 'element-ui/lib/theme-chalk/index.css'
import JsEncrypt from 'jsencrypt/bin/jsencrypt'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import 'babel-polyfill'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(preview)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueCookie)

Vue.prototype.$axios = axios
Vue.prototype.utils = utils
Vue.prototype.$jsEncrypt = JsEncrypt

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js